import React from 'react';
import { Heading, Image, Link, LinkProps, Text } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { media } from '@atlaskit/primitives/responsive';

const SimpleContentBlock: React.FC<{
  title: string;
  description: string;
  imageUrl: string;
  imageAlt: string;
  link: LinkProps;
}> = ({ title, description, imageUrl, imageAlt, link }) => (
  <div css={simpleContentBlockStyles}>
    <div>
      <Image src={imageUrl} alt={imageAlt} />
    </div>
    <Heading level={3}>{title}</Heading>
    <div css={descriptionStyles}>
      <Text size="regular">{description}</Text>
    </div>
    <Link {...link} />
  </div>
);

const simpleContentBlockStyles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: token('space.100'),
  padding: `10px ${token('space.300')} ${token('space.200')} ${token('space.300')}`,
  maxWidth: '390px',

  [media.below.md]: {
    margin: '0 auto',
    padding: `10px ${token('space.200')} ${token('space.200')} ${token('space.200')}`,
  },

  '& h3': {
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 700,
  },

  '& a:hover': {
    textDecoration: 'none',
  },

  '& a:hover span:last-of-type': {
    transform: 'translateX(4px)',
  },
});

const descriptionStyles = css({
  flexGrow: 1,
});

export default SimpleContentBlock;
